module.exports = __webpack_public_path__ + "img/5.6ac9e269.png";